import { format } from "date-fns";
import { setFormValues } from "../EditEmployeeModalSlice";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { Dispatch } from "redux";

export const setEmployeeFormValues = (
    selectedEmployee: EmployeeInterface,
    dispatch: Dispatch,
): void => {
    if (selectedEmployee) {
        dispatch(
            setFormValues({
                firstName: selectedEmployee?.user?.first_name,
                lastName: selectedEmployee?.user?.last_name,
                insertion: selectedEmployee?.user?.insertion,
                ...(selectedEmployee.function_groups?.length > 0
                    ? {
                          functionGroups: selectedEmployee.function_groups.map(
                              (functionGroup) => ({
                                  selectedId: functionGroup.id.toString(),
                                  selectedValue: functionGroup.name,
                              }),
                          ),
                      }
                    : { functionGroups: [] }),
                businessEmail: selectedEmployee?.person?.business_email,
                privateEmail: selectedEmployee?.user?.private_email,
                telephoneNumber: selectedEmployee?.person?.mobile_number,
                ...(selectedEmployee.date_of_birth
                    ? {
                          dateOfBirth: format(
                              selectedEmployee?.date_of_birth,
                              "yyyy-MM-dd",
                          ),
                      }
                    : {}),
                placeOfBirth: selectedEmployee?.place_of_birth,
            }),
        );
    }
};
